/**
 * @since 1.0.0
 */
import * as CP from "@effect/data/internal/Differ/ContextPatch";
const TypeId = CP.ContextPatchTypeId;
/**
 * An empty patch which returns the environment unchanged.
 *
 * @since 1.0.0
 * @category constructors
 */
export const empty = CP.empty;
/**
 * @since 1.0.0
 * @category constructors
 */
export const diff = CP.diff;
/**
 * Combines two patches to produce a new patch that describes applying the
 * updates from this patch and then the updates from the specified patch.
 *
 * @since 1.0.0
 */
export const combine = CP.combine;
/**
 * Applies a `Patch` to the specified `Context` to produce a new patched
 * `Context`.
 *
 * @since 1.0.0
 * @category destructors
 */
export const patch = CP.patch;
//# sourceMappingURL=ContextPatch.mjs.map